var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"page-img",attrs:{"src":require("@/assets/image/activity/ojk-page.jpg")}})])}]

export { render, staticRenderFns }